

import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  data: any;
  header: TableHeadersType[];
  history: any;
};
const HiringCheckListTableData = ({
  data,
  header,
  history,
 

}: AppProps) => {

  
  return (
    data?.length > 0 &&
    data?.map((dataItem: any) => {
      return (
        <tr>
          {header?.map((headerData: TableHeadersType) => {
           if (headerData?.value === "comp_discussed_accepted_email") {
              return <td 
              style={{minWidth:'200px', padding:"29px 0.75rem"}}
              >
                <span className={dataItem?.employee_details?.comp_discussed_accepted_email?"credit":'debit'}>{dataItem?.employee_details?.comp_discussed_accepted_email==false?"No":"Yes"}</span>
                </td>;
            } else if (headerData?.value === "background_check_complete_within_30_days") {
              return <td 
              style={{minWidth:'200px' , padding:"29px 0.75rem"}}

              >
                <span className={dataItem?.employee_details?.background_check_complete_within_30_days?"credit":"debit"}>
                {dataItem?.employee_details?.background_check_complete_within_30_days==false?"No":"Yes"}</span>
                </td>;
            } else if (headerData?.value === "offer_letter_signed") {
              return <td
              style={{minWidth:'200px' , padding:"29px 0.75rem"}}

              >
                <span className={dataItem?.employee_details?.offer_letter_signed?"credit":"debit"}>{dataItem?.employee_details?.offer_letter_signed==false?"No":"Yes"}</span>
                </td>;
            } else if (headerData?.value === "documentation") {
              return <td 
              style={{minWidth:'200px' , padding:"29px 0.75rem"}}

              >
               <span className={dataItem?.employee_details?.documentation?"credit":"debit"}> {dataItem?.employee_details?.documentation==false?"No":"Yes"}</span>
                </td>;
            } 
            else if (headerData?.value === "reference_call_feedback_received") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                <span className={dataItem?.employee_details?.reference_call_feedback_received?"credit":"debit"}>  {dataItem?.employee_details?.reference_call_feedback_received==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "passbook_bank_statement_xerox") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                <span className={dataItem?.employee_details?.passbook_bank_statement_xerox?"credit":"debit"}>  {dataItem?.employee_details?.passbook_bank_statement_xerox==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "appointment_letter_previous_org") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.appointment_letter_previous_org?"credit":"debit"}> {dataItem?.employee_details?.appointment_letter_previous_org==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "payslip_last_two_months") {
                return <td
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                <span className={dataItem?.employee_details?.payslip_last_two_months?"credit":"debit"}>  {dataItem?.employee_details?.payslip_last_two_months==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "income_tax_return") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.income_tax_return?"credit":"debit"}> {dataItem?.employee_details?.income_tax_return==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "offer_letter_previous_org") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                
                >
                 <span className={dataItem?.employee_details?.offer_letter_previous_org?"credit":"debit"}> {dataItem?.employee_details?.offer_letter_previous_org==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "relieving_letter_previous_org") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.relieving_letter_previous_org?"credit":"debit"}> {dataItem?.employee_details?.relieving_letter_previous_org==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "experience_letter_previous_org") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
               <span className={dataItem?.employee_details?.experience_letter_previous_org?"credit":"debit"}>{dataItem?.employee_details?.experience_letter_previous_org==false?"No":"Yes"}</span>   
                  </td>;
              } 
              else if (headerData?.value === "icai_intimation") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem", whiteSpace:'nowrap'}}

                
                >
                   {dataItem?.employee_details?.icai_intimation
                                            ?.length > 20 ? (
                                            <OverlayTrigger
                                              placement="top"
                                              delay={{ show: 250, hide: 250 }}
                                              overlay={
                                                <Tooltip id="button-view-open-item">
                                                  {
                                                   dataItem?.employee_details?.icai_intimation
                                                  }
                                                </Tooltip>
                                              }
                                            >
                                              <span
                                              
                                              >
                                                {dataItem?.employee_details?.icai_intimation.slice(
                                                  0,
                                                  20
                                                )}
                                                ...
                                              </span>
                                            </OverlayTrigger>
                                          ) : (
                                            <span
                                              
                                            >
                                              {
                                               dataItem?.employee_details?.icai_intimation
                                              }
                                            </span>
                                          )}
                  </td>;
              } 
              else if (headerData?.value === "hris_form_filled") {
                return <td
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                
                >
                 <span  className={dataItem?.employee_details?.hris_form_filled?"credit":"debit"}> {dataItem?.employee_details?.hris_form_filled==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "finac_knowledge") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.finac_knowledge?"credit":"debit"}> {dataItem?.employee_details?.finac_knowledge==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "holiday_list") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.holiday_list?"credit":"debit"}> {dataItem?.employee_details?.holiday_list==false?"No":"Yes"}</span>
                  </td>;
              } 
              else if (headerData?.value === "hr_policies") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                <span className={dataItem?.employee_details?.hr_policies?"credit":"debit"}> {dataItem?.employee_details?.hr_policies==false?"No":"Yes"}</span> 
                  </td>;
              } 
              else if (headerData?.value === "pto_tool") {
                return <td
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.pto_tool?"credit":"debit"}>{dataItem?.employee_details?.pto_tool==false?"No":"Yes"}</span> 
                  </td>;
              } 
              else if (headerData?.value === "stationary_items") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.stationary_items?"credit":"debit"}>{dataItem?.employee_details?.stationary_items==false?"No":"Yes"}</span> 
                  </td>;
              } 
              else if (headerData?.value === "email_id_creation") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span className={dataItem?.employee_details?.email_id_creation?"credit":"debit"}>{dataItem?.employee_details?.email_id_creation==false?"No":"Yes"}</span> 
                  </td>;
              } 
              else if (headerData?.value === "employee_code") {
                return <td 
                style={{minWidth:'200px' , padding:"29px 0.75rem"}}

                >
                 <span  className={dataItem?.employee_details?.employee_code?"credit":"debit"}> {dataItem?.employee_details?.employee_code==false?"No":"Yes"}</span>
                  </td>;
              } 
          })}
        </tr>
      );
    })
  );
};

export default HiringCheckListTableData;
